import qs from 'qs';
import ClipboardJS from 'clipboard';

/** 获取链接参数 */
export const getUrlParams = () => {
    const _str = window.location.search.split('?')[1] || '';
    console.log('-- getUrlParams', qs.parse(_str));
    return qs.parse(_str);
};
// 浏览器信息解析方法
export const getSystemInfo = () => {
    const u = navigator.userAgent.toLowerCase();
    const qmVersionMatch = u.match(/webviewversion\/(\d+)/);
    const qmVersionMatch2 = u.match(/qmbrowser\/(\d+)/);
    const qmVersionMatchNew = u.match(/com\.yueyou\.cyreader\/(\d+)/);
    // 新版统一使用 com.yueyou.cyreader 判断， 旧版安卓webviewversion， ios qmbrowser
    // 旧版ios 在域名白名单内时会加上 webviewversion，但存在接口时机问题
    let appVersion = qmVersionMatchNew ? qmVersionMatchNew[1] : qmVersionMatch ? qmVersionMatch[1] : qmVersionMatch2 ? qmVersionMatch2[1] : '';
    const isIos = !!u.match(/mac os x/); // ios
    const isAndroid = u.indexOf('android') > -1 || u.indexOf('linux') > -1; // android
    const isHarmony = u.indexOf('openharmony') > -1; // 鸿蒙
    const isWeixin = u.indexOf('micromessenger') > -1; // 微信
    const isTrident = u.indexOf('trident') > -1; // IE内核
    const isQQ = !!u.match(/\sqq/i); // QQ
    const isWeibo = u.indexOf('weibo') > -1; // 微博

    const adData = {
        adper: u.match(/adper\/(\d+)/) || [],
        adpro: u.match(/adpro\/(\d+)/) || [],
        stable: u.match(/stable\/(\d+)/) || 0, // 设备稳定性 0是稳定，1是不稳定
    };

    if (import.meta.env.VITE_ENV === 'dev') {
        appVersion = '7777777';
    }
    return {
        appVersion: +appVersion || 0, // app 版本
        inQmApp: !!appVersion, // 是否在app内
        isTrident,
        isIos,
        isAndroid,
        isHarmony,
        platform: (isIos ? 'ios' : isHarmony ? 'harmonyos' : 'android') as 'ios' | 'android' | 'harmonyos',
        isWeixin,
        isQQ,
        isWeibo,
        adData,
    };
};

/**
 * @description: 获取所处环境
 * @return {number}
 */
export const getAppEnv = () => {
    const regExp = /test\-env\/(\S*)/;
    if (navigator?.userAgent?.toLowerCase()?.match(regExp)) {
        return (navigator?.userAgent?.toLowerCase()?.match(regExp) as string[])[1];
    }
    return '';
};

// 非正式环境请求url需要加-test
export const changeEnvUrl = (str: string) => {
    // 例如 http://xiaoshuo.wtzw.com 会被格式化成 http://xiaoshuo-test.wtzw.com
    return str.replace(/http[s]?:\/\/[\s\S]+.com/, (regStr) => {
        const arr = regStr.split('.') || [];
        arr[0] = `${arr[0]}-test`;
        return arr.join('.');
    });
};

// 时间格式化
export function formatDate(dateTime: number, fmt = 'YYYY-MM-DD') {
    const date = new Date(dateTime);
    const o = {
        'Y+': date.getFullYear(), // 年份
        'M+': date.getMonth() + 1, // 月份
        'D+': date.getDate(), // 日
        'H+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
    };
    if (/(Y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substring(4 - RegExp.$1.length));
    }
    for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substring(`${o[k]}`.length));
        }
    }
    return fmt;
}

// storage 使用 jsbStorage

// --start sessionStorage
export function setSession(key: string, value: any) {
    let _val = value;
    if (typeof value === 'object') {
        _val = JSON.stringify(value);
    }
    sessionStorage.setItem(key, _val);
}
export function getSession(key: string) {
    const _value = sessionStorage.getItem(key);
    try {
        const _val = JSON.parse(_value!);
        if (typeof _val === 'object') {
            return _val;
        }
        return _value;
    } catch (e) {
        return _value;
    }
}
export function removeSession(key: string) {
    if (key) {
        sessionStorage.removeItem(key);
    } else {
        sessionStorage.clear();
    }
}
// --end

// 处理数字，兼容精度问题
export const formatNumber = (num: number, digits = 1) => {
    if (Number.isInteger(num)) {
        return num;
    }
    return parseFloat(num.toFixed(digits));
};

// 数字千分位格式化
export const formatThousands = (value: number | string) => {
    if (value === null || value === undefined) {
        return '';
    }

    const originValue = String(value).trim();
    if (!originValue) {
        return '';
    }

    const normalizedValue = originValue.replace(/,/g, '');
    if (!/^[+-]?\d+(\.\d+)?$/.test(normalizedValue)) {
        return originValue;
    }

    const hasNegativeSign = normalizedValue.startsWith('-');
    const unsignedValue = normalizedValue.replace(/^[+-]/, '');
    const [integerPart, decimalPart] = unsignedValue.split('.');
    const integerWithThousands = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return `${hasNegativeSign ? '-' : ''}${integerWithThousands}${decimalPart !== undefined ? `.${decimalPart}` : ''}`;
};

// 兼容requestIdleCallback
export const polyfillRequestIdleCallback = () => {
    if (!window.requestIdleCallback) {
        window.requestIdleCallback = function(cb) {
            const start = Date.now();
            return setTimeout(function() {
                cb({
                    didTimeout: false,
                    timeRemaining: function() {
                        return Math.max(0, 50 - (Date.now() - start));
                    },
                });
            }, 1);
        };
    }
};

/** 复制文本到剪贴板，返回是否成功 */
export async function copyToClipboard(content: string): Promise<boolean> {
    return new Promise((resolve) => {
        if (!document.body) {
            resolve(false);
            return;
        }

        const fakeElement = document.createElement('button');
        const clipboard = new ClipboardJS(fakeElement, {
            text: () => content,
        });

        const cleanUp = () => {
            clipboard.destroy();
            fakeElement.remove();
        };

        clipboard.on('success', () => {
            cleanUp();
            resolve(true);
        });

        clipboard.on('error', () => {
            cleanUp();
            resolve(false);
        });

        fakeElement.click();
    });
}

/**
 * 扩展的错误类型，包含 isNetworkError 属性
 */
export interface ExtendedError extends Error {
    isNetworkError?: boolean;
}

/**
 * 接收一个 Promise，并返回一个元组 [error, data]
 * @param {Promise<T>} promise - 要处理的 Promise
 * @returns {Promise<[ExtendedError | null, T | undefined]>} 返回一个包含错误和数据的元组
 */
export function to<T>(promise: Promise<T>): Promise<[ExtendedError | null, T | undefined]> {
    return promise.then(((data: Record<string, any>) => [null, data as T]) as (value: T) => [null, T]).catch<[ExtendedError, undefined]>((err: ExtendedError) => [err, undefined]);
}


